<template>
  <div>
    <form @submit.prevent="submitFilters">
      <div class="row">
        <div class="col-12 col-md-6 mb-2">
          <label class="akkurate-dark small" for="date">From Date</label>
          <b-form-group label-for="start_date" class="akkurate-dark">
            <b-form-input id="start_date" class="mt-1 field-container fields" type="date" v-model="form.start_date">
            </b-form-input>
          </b-form-group>
        </div>

        <div class="col-12 col-md-6 mb-2">
          <label class="akkurate-dark small" for="date">To Date</label>
          <b-form-group label-for="end_date" class="akkurate-dark">
            <b-form-input id="end_date" class="mt-1 field-container fields" type="date" v-model="form.end_date">
            </b-form-input>
          </b-form-group>
        </div>

        <div class="col-12 col-md-6 mb-2">
          <label class="akkurate-dark small" for="search">Transaction Type</label>
          <b-form-group id="transaction_type" label-for="transaction_type" class="akkurate-dark">
            <multiselect class="mt-1 field-container" v-model="form.transaction_type" :options="transaction_types"
              selectLabel="" deselectLabel="">
            </multiselect>
          </b-form-group>
        </div>
        <div class="col-12 col-md-6 mb-2">
          <label class="akkurate-dark small" for="status">Status</label>
          <b-form-group id="status" label-for="status" class="akkurate-dark">
            <multiselect class="mt-1 field-container" v-model="form.status" :options="statuses"
              placeholder="Select status" selectLabel="" deselectLabel="">
            </multiselect>
          </b-form-group>
        </div>
        <div class="col-12 col-md-6 mb-2">
          <label class="akkurate-dark small" for="status">Loan Status</label>
          <b-form-group id="status" label-for="status" class="akkurate-dark">
            <multiselect class="mt-1 field-container" v-model="form.loan_status" :options="loan_status_options"
              placeholder="Select status" selectLabel="" deselectLabel="">
            </multiselect>
          </b-form-group>
        </div>

        <div class="col-12 col-md-6 mb-2">
          <label class="akkurate-dark small" for="trans_source">Source</label>
          <multiselect class="field-container mt-1" v-model="form.trans_source" :options="trans_source_options"
            placeholder="Transaction Source" label="name" selectLabel="" deselectLabel="">
          </multiselect>
        </div>



        <div class="col-12 col-md-6 mb-2">
          <label class="akkurate-dark small" for="branch">Branch</label>
          <multiselect class="mt-1 field-container" v-model="form.branch" :options="branch_option" track-by="name"
            placeholder="Select one" selectLabel="" deselectLabel="" label="name">
          </multiselect>
        </div>

        <div class="col-12 col-md-6 mb-2">
          <label class="akkurate-dark small" for="branch">Terms</label>
          <multiselect class="mt-1 field-container" v-model="form.term" :options="terms_option" placeholder="Select one"
            selectLabel="" deselectLabel="">
          </multiselect>
        </div>

        <div class="col-12 col-md-6 mb-2">
          <label class="akkurate-dark small" for="transaction_mode">Transaction Mode</label>
          <multiselect class="mt-1 field-container" :multiple="true" :close-on-select="false" :clear-on-select="false"
            v-model="form.transaction_mode" :options="transaction_mode_option" placeholder="Select one" selectLabel=""
            deselectLabel="">
          </multiselect>
        </div>
        <div class="col-12 col-md-6 mb-2">
          <label class="akkurate-dark small" for="transaction_mode">Gender</label>
          <multiselect class="mt-1 field-container" v-model="form.gender" :options="gender_options"
            placeholder="Select gender" selectLabel="" deselectLabel="">
          </multiselect>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
  components: {
    Multiselect
  },
  props: ['form', 'users', 'branch_option'],
  data() {
    return {
      more_details: false,
      // transaction_options: ['Deposit', 'Withdrawal'],
      // sources: ['Mobile', 'WEB', 'USSD']
      statuses: ['COMPLETED', 'PENDING', 'REVERSED', 'REJECTED'],
      transaction_types: ['Loan Disbursed', 'Loan Repayment',],
      loan_status_options: ['PENDING', 'UNDER_REVIEW', 'RUNNING', 'DISBURSED', 'CLOSED', 'REJECTED', 'WRITTEN_OFF'],
      terms_option: ['YTD', 'Periodic', 'Trashed'],
      transaction_mode_option: ['Cash', 'Cheque', 'Transfer', 'Adjustment', 'Set-Off','USSD'],
      // sources: [{ name: 'USSD', id: "USSD" }, { name: 'WEB', id: "WEB" }, { name: 'MOBILE BANKER', id: "Mobile_Banker" }],
      // code_option: [
      //   { name: "Customer code", value: "filter" },
      //   { name: "Account #", value: "account_number" },
      //   { name: "Ref.No", value: "code" },
      //   { name: "Mobile", value: "phone_number" },
      // ],
      trans_source_options: [
        { name: 'USSD', value: "ussd" },
        { name: 'OFFICE', value: "office" },
        { name: 'MOBILE', value: "mobile" },
        // { name: 'Deposit', value: "deposit" },
        // { name: 'Withdrawal', value: "withdrawal" },
      ],
      gender_options: ['Male', 'Female', 'Group']
      // trans_sources: ["Deposit", "Withdrawal"]

    }
  },
  methods: {
    submitFilters() {
      this.$emit("submitFilters");
    },



    show_more() {
      this.more_details = !this.more_details
    }
  }
}

</script>